import { empApi } from "./client";

// Danh sách TTKQ -> { items, pagination }
export const getTtkqListApi = (params) => empApi.get("/ttkq/app", params);

// Chi tiết TTKQ
export const getTtkqByIdApi = (id) => empApi.get(`/ttkq/app/${id}`);
